"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreferencesSection = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
var _LanguageSelect = require("../LanguageSelect");
var _style = require("./style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PreferencesSection = () => {
  const {
    container,
    activeContainer,
    settings
  } = (0, _style.useStyles)();
  const [isOpen, setOpen] = (0, _react.useState)(false);
  const toggleOpen = () => {
    setOpen(prevState => !prevState);
  };
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)(container, {
      [activeContainer]: isOpen
    }),
    sx: {
      '&:hover': {
        opacity: 1
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: toggleOpen,
    color: "primary"
  }, isOpen ? /*#__PURE__*/_react.default.createElement(_icons.Close, null) : /*#__PURE__*/_react.default.createElement(_icons.Settings, null)), /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: settings
  }, /*#__PURE__*/_react.default.createElement(_LanguageSelect.LanguageSelect, null)));
};
exports.PreferencesSection = PreferencesSection;